const voyagerGallery = document.querySelector('.voyager-gallery');
const filterTab = voyagerGallery?.querySelector('.js-gallery-filter-tab');

class GalleryFilter {
    constructor() {
        this.filterTabLink = filterTab?.getElementsByTagName('button');
        this.filterMobileTab = voyagerGallery?.querySelector('.js-gallery-filter-tab-mobile');
        this.galleryWrapper = voyagerGallery?.querySelectorAll('.js-voyager-gallery__wrapper');
    }

    handleMobileTab() { 
        var _self = this;
        _self.filterMobileTab.addEventListener('click', (e) => {
            var parentElement = e.target.parentElement;
            parentElement.classList.add('is_active');
        })
    }

    filterListItem() {
        var _self = this;
        for (const item of _self.filterTabLink) {
            _self.getFolderID(item);
        }
    }

    getFolderID(item) {
        var _self = this;
        item.addEventListener('click', (e) => {
            e.preventDefault();
            var folderID = e.target.dataset.folderid;
            _self.removeClassFromItems();
            _self.addClassToItem(e);
            _self.filterMobileTab.parentElement.classList.remove('is_active');
            _self.filterMobileTab.innerHTML = e.target.innerHTML;
            this.imageListItems(folderID);
        })
    }

    addClassToItem(event) {
        const clickedItem = event.target;
        clickedItem.classList.add('is_active');
    }

    removeClassFromItems() {
        var _self = this;
        for (const item of _self.filterTabLink) {
            item.classList.remove('is_active'); 
        }
    }

    imageListItems(folderID) {
        var _self = this;

        for (const item of _self.galleryWrapper) {
            item.classList.remove('is_hidden');
            var wrapFolderId = '';
            if(folderID) {
                wrapFolderId = item.dataset.folderid;
                if(folderID != wrapFolderId) {
                    item.classList.add('is_hidden')
                }
            }
        }
    }

    init() {
        if(!filterTab) return false;
        this.filterListItem();
        this.handleMobileTab();
    };
}

const galleryFilter = new GalleryFilter();

/**
 * Initialize the script when the block is previewed within the editor
 * https://www.advancedcustomfields.com/resources/javascript-api/
 */
if (window.acf) {
	window.acf.addAction("render_block_preview/type=voyager-gallery", function () {
		galleryFilter.init();
	});
} else {
	window.addEventListener("load", () => {
		galleryFilter.init();
	});
}